"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _jsonrpc = require("../jsonrpc");

var _web3Calls = _interopRequireDefault(require("../web3Calls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var WAIT_TIME = 10 * 1000; //10 seconds

var memcache = {
  timestamp: 0,
  blockNumber: 0
};

var _default = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, res, next) {
    var payload, requestManager, ethCalls, blockNumber;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload, requestManager = _ref.requestManager;

            if (!(payload.method !== 'eth_blockNumber')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", next());

          case 3:
            ethCalls = new _web3Calls.default(requestManager);

            if (!(memcache.timestamp < new Date().getTime() - WAIT_TIME)) {
              _context.next = 19;
              break;
            }

            _context.prev = 5;
            _context.next = 8;
            return ethCalls.getBlockNumber();

          case 8:
            blockNumber = _context.sent;
            memcache.blockNumber = blockNumber;
            memcache.timestamp = new Date().getTime();
            res(null, (0, _jsonrpc.toPayload)(payload.id, blockNumber));
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](5);
            res(null, (0, _jsonrpc.toPayload)(payload.id, null));

          case 17:
            _context.next = 20;
            break;

          case 19:
            res(null, (0, _jsonrpc.toPayload)(payload.id, memcache.blockNumber || null));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 14]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.default = _default;